import Link from '../../views/ChangePassword';
import { connect } from 'react-redux';
import { actions } from '../../../state/assessment';
import { actions as Authaction } from '../../../state/auth';
import { push } from 'connected-react-router';

const mapStateToProps = (state, ownProps) => ({
  intel: ownProps.match.params.intel,
  locale: ownProps.match.params.locale,
  status2: state.shift.status,
  username: state.shift.auth.username,
  status: state.shift.auth.status,
});

const mapDispatchToProps = (dispatch, ownProps) => {
  const { locale } = ownProps.match.params;
  return {
    forgetpassword: email => {
      dispatch(actions.forgetpassword(email)).then(res => {
        //window.close();
        dispatch(push(`/${locale}/passwordforgotmsg`));
      });
    },

    changepassword: (password,newpassword,renewpassword,username,showMessageTrue,openModal) => {
      if(renewpassword !== newpassword){
        return openModal();
      }

      dispatch(actions.changepassword(username,password,newpassword)).then(res => {
        //window.close();
        // if(res.value.code === "200"){
          showMessageTrue();
          // dispatch(push(`/${locale}/passwordforgotmsg`));
        // }else{
        //   console.log("password changed failed");
        // }
      });
    },

    logout: () => {
      localStorage.clear();
      sessionStorage.clear();
      dispatch(Authaction.logout());
    },


  };
};

const ChangePassword = connect(
  mapStateToProps,
  mapDispatchToProps
)(Link);

export default ChangePassword;



// WEBPACK FOOTER //
// ./src/components/container/ChangePassword/index.js